import React, { useState, useEffect, useRef } from "react"
import Loader from "react-loader-spinner"
import axios from "axios"

export default function Loader1() {
  const [showLoader, setShowLoader] = useState(false)
  const requestCounter = useRef(0)

  useEffect(() => {
    // Request Interceptor
    axios.interceptors.request.use(
      config => {
        // use config instead of response, but no structure changes requested
        if (
          config.url.endsWith("/check-camspay-mandate-status") ||
          config.url.endsWith("/policy-download-pdf-quotation")
        ) {
          // skip loader for these
        } else {
          requestCounter.current++
          setShowLoader(true)
        }
        return config
      },
      error => {
        if (requestCounter.current > 0) requestCounter.current--
        if (requestCounter.current === 0) setShowLoader(false)
        return Promise.reject(error)
      }
    )

    // Response Interceptor
    axios.interceptors.response.use(
      response => {
        if (requestCounter.current > 0) requestCounter.current--
        if (requestCounter.current === 0) setShowLoader(false)
        return response
      },
      error => {
        if (requestCounter.current > 0) requestCounter.current--
        if (requestCounter.current === 0) setShowLoader(false)
        return Promise.reject(error)
      }
    )
  }, [])

  return (
    <>
      {showLoader ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            background: "#80808061",
            position: "fixed",
            zIndex: "999999999999",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader
            type="Grid"
            color="var(--lumiq-secondary2)"
            height={100}
            width={100}
            visible={showLoader}
          />
        </div>
      ) : null}
    </>
  )
}
